import { mainUrl, client } from '../app-constants';

export function getPianoTechUserList() {
    const url = mainUrl + 'pt.users/listPianoTechUser'

    return client.get(url);
}

export function findPianoTechUser(userId) {
    const url = mainUrl + 'pt.users/findPianoTechUser?userId=' + userId;

    return client.get(url);
}

export function savePianoTechUser(pianoTechUser) {
    const url = mainUrl + 'pt.users/savePianoTechUser';

    return client.post(url,pianoTechUser);
}

